import styled from 'styled-components'

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
